export default __webpack_public_path__ + "static/media/LogoWhite.ff3315e5.svg";